export default function Profile({ profile }) {
  return (
    <div>
      <h2 className="text-xl font-semibold mt-6 mb-2">Experiences</h2>
      <ul className="list-disc pl-5">
        {profile?.experiences?.map((exp, index) => (
          <li key={index} className="mb-2">
            <strong>{exp.job_title}</strong> at {exp.company_name} ({exp.duration}) - {exp.description}
          </li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Comments</h2>
      <ul className="list-disc pl-5">
        {profile?.comments?.map((comment, index) => (
          <li key={index} className="mb-2">
            <strong>{comment.author}:</strong> {comment.text}
          </li>
        ))}
      </ul>
    </div>
  );
}
